<template>
    <div class="offline_main">
        <div class="offline_top">
            <div class="flex_box">
                <div class="flex_left">
                    <div class="left_box">
                        <div>
                            <img src="@/assets/success.png" alt="">
                            <span style="color: #87c256;font-size: 18px;font-weight: 600;">
                                订单已提交成功，请您及时付款，我们将尽快为您安排发货!
                            </span>
                        </div>
                        <div>
                            <span style="margin-right: 30px;">
                                订单编号： {{ order_no }} 
                            </span>
                            <span>
                                订单金额: 
                            </span>
                            <span style="color: tomato;font-weight: 600;margin-left: 10px;">
                                ￥ {{ total_price }}
                            </span>
                        </div>
                        <div>
                            <!-- (请在 14 天 23 小时 59 分 49 秒 内完成付款，否则订单将自动取消!) -->
                        </div>
                        <div style="margin-top: 20px;">
                            <el-button type="primary" @click="HandleFun">继续购物</el-button>
                            <!-- <el-button>查看订单</el-button> -->
                        </div>
                    </div>
                </div>
                <div class="flex_right">
                    <div class="right_box">
                        <p>
                            <span style="font-weight: 700;">注意事项</span> (转账必读)
                        </p>
                        <p>
                            1.公司转账汇款时请将订单编号{{ order_no }}填写至汇款单中“用途/备注/摘要”等栏;
                        </p>
                        <p>
                            2.下单后请尽快转账，务必保证转账金额与订单金额一致请勿多转/少转或分次转账，否则影响订单对账进度;
                        </p>
                        <p>
                            3.如存在个人汇款、第三方代汇款等情况，还需提供对应的代付/委托声明;代付证明加盖公章后请联系 
                            <span style="border-bottom: 1px solid #10aeff;color: #10aeff;cursor: pointer;"  @click="HandleSession">在线客服</span> 
                            <!-- 或拨打客服热线400-680-9696提交。点击下载代付证明模板 -->
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <p style="margin-top: 20px;font-size: 16px;">线下转账信息
            <span style="margin-left: 10px;font-size: 12px;color: #666666;">( <span style="font-size: 600;color: #333333;">温馨提示</span> ：请按照以下信息进行线下转账汇款操作)</span>
        </p>

        <div>
            <div class="mylabel"> 银行转账信息 </div>
            <el-descriptions :column="1" border>
                
                <el-descriptions-item label="公司信息">{{ transferData.company }}</el-descriptions-item>
                <el-descriptions-item label="银行账号">{{ transferData.bank_account }}</el-descriptions-item>
                <el-descriptions-item label="开户银行">{{ transferData.bank }}</el-descriptions-item>
                <el-descriptions-item label="银联号(CNAPS)">{{ transferData.cnaps }}</el-descriptions-item>
                <el-descriptions-item label="用途/备注/摘要">{{ transferData.remarks }}</el-descriptions-item>
                <el-descriptions-item label="税号">{{ transferData.duty_paragraph }}</el-descriptions-item>
                <el-descriptions-item label="电话">{{ transferData.phone }}</el-descriptions-item>
                <el-descriptions-item label="地址">{{ transferData.address }}</el-descriptions-item>
            </el-descriptions>
        </div>

        <p style="margin-top: 20px;font-size: 16px;">商品清单 </p>
        <div class="shangpInfo">
            <div>
                <div  class="InfoSelf-box" :style="!(vsData.ispay=='1') ? 'border: none;': ''">
                    <p>下单时间</p>
                    <span>{{ vsData.create_time }}</span>
                </div>
                <div  class="InfoSelf-box" v-if="(vsData.ispay=='1')" :style="(vsData.isconfirm!='1') ? 'border: none;': ''">
                    <p>付款时间</p>
                    <span>{{ vsData.pay_time }}</span>
                </div>
                <div class="InfoSelf-box" style="border: none;height: 30px;">
                    <div >
                        <div class="orderProvince">
                            <p>{{ vsData.province_name }}</p>
                            <p>{{ vsData.city_name }}</p>
                            <p>{{ vsData.county_name }}</p>
                            <p>{{ vsData.address }}</p>
                        </div>
                        <p style="margin-top: 10px;">{{ vsData.phone }}</p>

                    </div>
                </div>
                <div class="InfoSelf-box" v-if="(vsData.isconfirm=='1')" style="margin-top: -50px;">
                   
                    <div class="orderProvince">
                        <p>{{ vsData.contact }}</p>
                        <p>{{ vsData.phone }}</p>
                    </div>
                </div>
                <div class="InfoSelf-img" v-if="vsData.order_items != ''" >
                    <div v-if="vsData.order_items != ''" :style="'width: 150px; height: 90px;margin-right: 30px;background-image:url('+vsData.order_items[0].firstFile.FileUrl+');background-size: cover;background-repeat: no-repeat;background-position: center;'"></div>
                    
                    <div class="Info-name">
                        <p>{{ vsData.order_items[0].product_name }}</p>
                        <p class="num"><span>{{ vsData.order_items[0].atts_items_names }}，</span></p>
                        <p class="num">{{ vsData.order_items[0].price }} <span>x{{  vsData.order_items[0].amount }}</span> </p>
                    </div>
                </div>
            </div>
            <div class="invoiceCss" style="display: block;" v-show="invoiceAddress != ''">
                <p>发票信息</p>
                <div class="invoice_box" style="margin-top: 30px;">
                    <div>
                        <p>发票抬头</p>
                        <span>{{ invoiceInfo.name }}</span>
                    </div>
                    <div>
                        <!-- 1企业 -->
                        <p>发票类型</p> 
                        <span>{{ invoiceInfo.invoice_type == 1?'企业':'个人' }}</span>
                    </div>
                    <div>
                        <p>邮箱</p>
                        <span>{{ invoiceInfo.email }}</span>
                    </div>
                    <div v-if="invoiceInfo.invoice_type == 1">
                        <p>纳税人识别号</p>
                        <span>{{ invoiceInfo.identification }}</span>
                    </div>
                </div>
            </div>
            <div class="InfoSelf-box" style="height: 120px;display: block;" v-show="invoiceAddress != ''">
                <p>发票地址</p>
                <div style="margin-top: 30px;">
                        <div class="orderProvince">
                            <p>{{ invoiceAddress.province_name }}</p>
                            <p>{{ invoiceAddress.city_name }}</p>
                            <p>{{ invoiceAddress.county_name }}</p>
                            <p>{{ invoiceAddress.address }}</p>
                        </div>
                        <p style="margin-top: 10px;">{{ vsData.phone }}</p>

                    </div>
            </div>
           
            <div  class="InfoSelf-box" v-show="false">
                <p>商品金额</p>
                <span>￥{{ vsData.ptotal }}</span>
            </div>
            <div  class="InfoSelf-box" v-show="false">
                <p>运费</p>
                <span>￥{{ vsData.express_fee }}</span>
            </div>
            <div  class="InfoSelf-box" v-if="vsData.coupon_item_facevalue>0">
                <p>优惠券</p>
                <span>-{{ vsData.coupon_item_facevalue }}</span>
            </div>
            <div  class="InfoSelf-box">
                <p>余额支付</p>
                <span>-{{ vsData.use_user_money }}</span>
            </div>
            <div  class="InfoSelf-box">
                <p>订单总计</p>
                <span>￥{{ vsData.total }}</span>
            </div>
            <div  class="InfoSelf-box" v-if="(vsData.ispay=='1')">
                <p>使用积分</p>
                <span>-{{ vsData.use_profit_jifen }}</span>
            </div>
            <div class="InfoSelf-box">
                <p>实付金额</p>
                <span>￥{{ vsData.ptotal }}</span>
            </div>
        </div>

    </div>
</template>

<script>
import { getTimeDate } from '../../js/getTime.js'
export default{
    data(){
        return{
            total_price: '',
            order_no: '',
            transferData: [],
            vsData: [],
            econtact: '',
            ephone: '',
            eaddress: '',
            eprovince: '',
            eprovincev: '',
            ecity: '',
            ecityv: '',
            ecounty: '',
            ecountyv: '',
            invoiceAddress: '',
            invoiceInfo: ''
        }
    },
    methods: {
        HandleSession(){
            this.$router.push({
                path: '/session',
            })
        },
        HandleFun(){
            this.$router.push({
                path: '/funeng'
            })
        },
        handleInfo(val){
            const { href } = this.$router.resolve({
                path: '/infoSelf',
                query: {
                    order_no: val
                }
            })
            window.open(href, '_blank')
        },
        getInfoSelf(){
            let data = {
                order_no: this.$route.query.orderNo
            }
            
            this.$store.dispatch('personal/infoSelf',data)
                .then(res => {
                    if(res.ok){
                       
                        var info = res.data
                        if(info){
                            this.vsData = res.data

                            this.vsData.create_time = getTimeDate(this.vsData.create_time)
                            this.vsData.pay_time = getTimeDate(this.vsData.pay_time)
                            
                            var contact=info.contact
                            this.invoiceAddress = ''
                            this.invoiceInfo = ''
                            var contact=info.contact
                            if(this.vsData.invoiceAddressInfo != ''){
                                this.invoiceAddress = this.vsData.invoiceAddressInfo
                                this.invoiceInfo = this.vsData.invoiceInfo
                            }

                            console.log(this.invoiceAddress);
                                
                            if(!(contact=='')){
                            
                                
                                this.econtact=info.contact
                                this.ephone=info.phone
                                this.eaddress=info.address
                                this.eprovince=info.province_code
                                this.eprovincev=info.province_name
                                this.ecity=info.city_code
                                this.ecityv=info.city_name
                                this.ecounty=info.county_code
                                this.ecountyv=info.county_name
                            }
                        }
                      
                    }
                })
        }
    },
    mounted(){
        if(this.$route.query.orderNo){
            this.order_no = this.$route.query.orderNo
        }
        if(this.$route.query.total_price){
            this.total_price = this.$route.query.total_price
        }
        let data = {}
        this.$store.dispatch('personal/transferInfo',data)
            .then(res => {
                if(res.ok){
                    this.transferData = res.data
                }
            })
        this.getInfoSelf()
    }
}
</script>

<style scoped lang="scss">
.offline_main{
    width: 1200px;
    margin: 30px auto;
    margin-bottom: 30px;
    .offline_top{
        padding: 20px 20px;
        height: 280px;
        
        background-color: #fff;
        .flex_box{
            background-color: rgba(204, 237, 255, 0.2);
            height: 100%;
            display: flex;
            justify-content: flex-start;
            .flex_left{
                width: 62%;
                text-align: center;
                .left_box{
                    padding: 20px 20px;
                    border-right: 1px solid #ffffff;
                    font-size: 14px;
                    color: #666666;
                    line-height: 55px;
                    div{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        img{
                            width: 40px;
                            height: 40px;
                            margin-right: 20px;
                        }
                    }
                }
                
                
            }
            .flex_right{
                width: 35%;
                margin-left: 1.4%;
                .right_box{
                    padding: 20px 20px;
                    font-size: 13px;
                    p{
                        line-height: 22px;
                        margin-top: 10px;
                    }
                }
            }
        }
    }
    .mylabel {
        background: #d9d9d9;
        font-size: 16px;
        padding: 10px 20px;
        color: #737373;
        font-weight: 600;
        margin-top: 20px;
    }

    // .my-content {
    //     background: #FDE2E2;
    // }

    .shangpInfo{
        margin-top: 20px;
        background-color: #ffffff;
    }
    
}
::v-deep .el-descriptions-item__label.is-bordered-label{
    background-color: #ffffff !important;
    color: #737373 !important;
    width: 280px;
    padding-left: 20px;
}
// ::v-deep .el-descriptions tr{
//     height: 20px !important;
// }
.invoiceCss{
    width: 900px;
   
    font-size: 18px;
    padding: 20px 20px;
    margin: 10px auto;
    margin-bottom: 30px;
    border-bottom: 0.5px solid #f2f2f2;
    .invoice_box{
        div{
            display: flex;
            justify-content: space-between;
            align-items: center;
            line-height: 50px;
            span{
                color: #10aeff;
            }
        }
        
    }
}
</style>